import IconBtn from "./IconBtn";

export default function ConfirmationModal({ modalData }) {
  return (
    <div className="fixed inset-0 z-[1000] grid place-items-center overflow-auto bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="w-11/12 max-w-[400px] rounded-lg border border-gray-300 bg-white  p-8">
        <p className="text-xl font-bold text-gray-800 bg-white">{modalData?.text1}</p>
        <p className="mt-2 mb-4 text-gray-600 bg-white">{modalData?.text2}</p>
        <div className="flex items-center justify-between gap-3">
          <IconBtn
            onclick={modalData?.btn1Handler}
            text={modalData?.btn1Text}
            outline={true}
            customClasses="flex-1 sgew-btn-primary" // the shared button colours (SGEW 17 Oct)
          />
          <IconBtn
            onclick={modalData?.btn2Handler}
            text={modalData?.btn2Text}
            customClasses="flex-1 sgew-btn-cancel" // equal width for both buttons
          />
        </div>
      </div>
    </div>
  );
}
